<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-oauth-authorize">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/login.png"
                alt="login"
                class="mx-auto"
                style="width: 100%; height: 100%; object-fit: contain;"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 pb-8">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Authorize MCP Server</h4>
                  <p>Please login to authorize this application.</p>
                </div>

                <div v-if="errorMessage" class="mb-4">
                  <vs-alert color="danger" icon-pack="feather" icon="icon-alert-circle">
                    {{ errorMessage }}
                  </vs-alert>
                </div>

                <vs-input
                  v-validate="'required|email|min:3'"
                  data-vv-validate-on="blur"
                  name="email"
                  icon-no-border
                  icon="icon icon-user"
                  icon-pack="feather"
                  label-placeholder="Email"
                  v-model="email"
                  class="w-full"
                />
                <span class="text-danger text-sm">{{ errors.first('email') }}</span>

                <vs-input
                  v-on:keyup.enter="handleLogin"
                  data-vv-validate-on="blur"
                  v-validate="'required|min:4|max:64'"
                  type="password"
                  name="password"
                  icon-no-border
                  icon="icon icon-lock"
                  icon-pack="feather"
                  label-placeholder="Password"
                  v-model="password"
                  class="w-full mt-6"
                />
                <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                <div class="flex flex-wrap justify-end mt-6">
                  <vs-button :disabled="!validateForm" @click="handleLogin">Authorize</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import jwt from '@/http/requests/auth/jwt/index.js'

export default {
  inject: ['$validator'],
  data() {
    return {
      email: '',
      password: '',
      errorMessage: '',
      codeChallenge: '',
      redirectUri: '',
      state: '',
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email !== '' && this.password !== ''
    },
  },
  created() {
    // Extract OAuth parameters from query string
    this.codeChallenge = this.$route.query.code_challenge
    this.redirectUri = this.$route.query.redirect_uri
    this.state = this.$route.query.state

    // Validate required OAuth parameters
    if (!this.codeChallenge || !this.redirectUri || !this.state) {
      this.errorMessage = 'Missing required OAuth parameters'
    }
  },
  methods: {
    async handleLogin() {
      if (!this.validateForm) return

      this.$vs.loading()
      this.errorMessage = ''

      try {
        // Call the login API
        const response = await jwt.login(this.email, this.password)

        if (response.body && response.body.user && response.body.jwt) {
          // Generate a random one-time authorization code
          const authCode = uuidv4()

          // Store the authorization code with associated data
          await this.storeAuthorizationCode(authCode, response.body.jwt)

          // Redirect to Claude callback
          const callbackUrl = `claude://callback?code=${authCode}&state=${this.state}`
          window.location.href = callbackUrl
        } else {
          this.errorMessage = 'Invalid credentials'
        }
      } catch (error) {
        console.error('Login error:', error)
        this.errorMessage = 'Invalid credentials'
      } finally {
        this.$vs.loading.close()
      }
    },
    async storeAuthorizationCode(code, token) {
      try {
        // Try to store on the server if the API endpoint exists
        await jwt.storeOAuthCode(code, token, this.codeChallenge)
      } catch (error) {
        console.warn('Server-side storage not available, using localStorage fallback')
        // Fallback to localStorage if server endpoint doesn't exist yet
        const authData = {
          code: code,
          token: token,
          code_challenge: this.codeChallenge,
          expires_at: Date.now() + 5 * 60 * 1000, // 5 minutes from now
        }
        const storedCodes = JSON.parse(localStorage.getItem('oauth_codes') || '{}')
        storedCodes[code] = authData
        localStorage.setItem('oauth_codes', JSON.stringify(storedCodes))
      }
    },
  },
}
</script>

<style lang="scss">
#page-oauth-authorize {
  .con-tab {
    padding-bottom: 14px;
  }
}
</style>
